// @ts-nocheck
import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import RouterActivationWizardBlockData from "../../../Models/Content/RouterActivationWizardBlockData";
import RouterActivationWizardComponent from "./RouterActivationWizardComponent";

export default class RouterActivationWizardBlock extends EpiComponent<RouterActivationWizardBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return (
      <RouterActivationWizardComponent
        context={this.getContext()}
        data={this.props.data}
      />
    );
  }
}
